import axios from "axios";
import Vue from "vue" 
import qs from "qs";
import { getToken } from "@/utils/token";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import router from "@/router";

const service = axios.create({
  baseURL: '/api',
  // timeout: 20000, // 设置超时时长
});

// 请求拦截器
service.interceptors.request.use(config => {
  if(getToken()) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
  }
  if (config.headers["Content-Type"] == "application/x-www-form-urlencoded; charset=utf-8") {
    config.data = qs.stringify(config.data);
  }
  return config;
})


// 响应拦截器
service.interceptors.response.use(response => {
  if (response.status === 200) { 
    if (response.data instanceof Blob) {
      return response.data;
    } else if(response.data.code === 401 && getToken()){
      MessageBox.confirm('当前用户登录失效，请重新登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('logout')
      }).catch(() => {
        store.dispatch('logout')          
      })
      return Promise.reject(response.data.msg);
    } else if(response.data.code != 200){
      // if(!getToken() && router.currentRoute?.meta?.requireAuth) {
      //   console.log('response.data.msg', response.data.msg)
      // }else {
      // }
      Message.error(response.data.msg || '系统错误', 3000)
      return Promise.reject(response.data.msg);
    } else {
      return response.data;
    }
  }else {
    return Promise.reject(response.data.msg);
  }
},function (error) {
  return Promise.reject(error);
})

class http {
  static get(url, params = {}, headers = {}) {
    return service.get(url, { params, headers });
  }
  static post(url, data = {}, headers = {}) {
    return service.post(url, data, { headers });
  }
  static postBody(
    url,
    data = {},
    headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    }
  ) {
    return service.post(url, data, { headers });
  }
  static put(url, params = {}, headers = {}) {
    return service.put(url, params, { headers });
  }
  static upFile(url, file) {
    return service.post(url, file, {
      headers: { "Content-Type": false  },
    });
  }
  static downFile(url, params = {}) {
    return service.post(url, params, {
      responseType: "blob",
    });
  }
}

export default http;